import React from "react";
import { Card, Menu, Dropdown, Modal, Divider, Tooltip, Row, Col } from "antd";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { useMutation } from "@apollo/react-hooks";
import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { GET_DASHBOARD_ITEMS } from "../graphql/queries";
import { DELETE_DASHBOARD_ITEM } from "../graphql/mutations";

const DashboardItemDropdown = ({ itemId }) => {
  const [removeDashboardItem] = useMutation(DELETE_DASHBOARD_ITEM, {
    refetchQueries: [
      {
        query: GET_DASHBOARD_ITEMS,
      },
    ],
  });
  const dashboardItemDropdownMenu = (
    <Menu>
      <Menu.Item>
        <Link to={`/explore?itemId=${itemId}`}>Edit</Link>
      </Menu.Item>
      <Menu.Item
        onClick={() =>
          Modal.confirm({
            title: "Are you sure you want to delete this item?",
            okText: "Yes",
            okType: "danger",
            cancelText: "No",

            onOk() {
              removeDashboardItem({
                variables: {
                  id: itemId,
                },
              });
            },
          })
        }
      >
        Delete
      </Menu.Item>
    </Menu>
  );
  return (
    <Dropdown
      overlay={dashboardItemDropdownMenu}
      placement="bottomLeft"
      trigger={["click"]}
    >
      <MenuOutlined />
    </Dropdown>
  );
};

const DashboardItem = ({ itemId, children, title }) => (
  <Card
    id={itemId}
    style={{
      borderRadius: "20px",
      boxShadow: "0 4px 30px 0 rgba(0, 0, 0, 0.1)",
      width: "100%",
      height: "100%",
    }}
  >
    <Row justify='space-between'>
      <Col>
        <h2>{title}</h2>
        <h3 style={{ color: "#9A9A9A" }}>Subtitle placeholder</h3>
      </Col>
      <Col>
        <DashboardItemDropdown itemId={itemId} />
      </Col>
    </Row>
    <Row align='middle'>
      {children}
    </Row>
    <div style={{ position: "fixed", bottom: 15, left: 15, width: "95%" }}>
      <Divider />
      <div
        id="cardFooter"
        style={{ display: "flex", width: "100%", alignItems: "center" }}
      >
        <Tooltip
          placement="topLeft"
          title="Chart description that could offer further explanation..."
        >
          <AiOutlineQuestionCircle
            style={{ fontSize: "150%", marginRight: "5px" }}
          />
        </Tooltip>
      </div>
    </div>
    {/* 
    <div
      style={{ display: "flex", flexDirection: "column" }}
    >
      <div style={{ width: "100%" }}>
        <span style={{ float: "left" }}>
          <h2>{title}</h2>
          <h3 style={{ color: "#9A9A9A" }}>Subtitle placeholder</h3>
        </span>
        <span style={{ float: "right" }}>
          {<DashboardItemDropdown itemId={itemId} />}
        </span>
      </div>
      <div id={`render-${itemId}`}>
        {children}
      </div>
      <div style={{ position: "fixed", bottom: 15, left: 15, width: "95%" }}>
        <Divider />
        <div
          id="cardFooter"
          style={{ display: "flex", width: "100%", alignItems: "center" }}
        >
          <Tooltip
            placement="topLeft"
            title="Chart description that could offer further explanation..."
          >
            <AiOutlineQuestionCircle
              style={{ fontSize: "150%", marginRight: "5px" }}
            />
          </Tooltip>
        </div>
      </div>
    </div> */}
  </Card>
);

export default DashboardItem;
